var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowTop = function SvgArrowTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 9,
    fill: "#00000080",
    viewBox: "0 0 122.88 80.593"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.88 80.593V49.772L61.44 0 0 49.772v30.821L61.44 30.82z"
  })));
};
export default SvgArrowTop;